

$(function () {

    if (!$('#navbar-collapse-winningnumbers').length) return;

});


// WEBPACK FOOTER //
// ./features/winning-numbers/winning-numbers-top-drawer/winning-numbers-top-drawer.js